import { TranslationModule } from "../../translation/translation.module";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { UserAccountRoutes } from "./user-account.routing";
import { ProfileComponent } from "./profile/profile.component";
import { AddressComponent } from "./address/address.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { OrdersComponent } from "./orders/orders.component";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { OrderDetailsComponent } from "./orders/order-details/order-details.component";
import { WilayaItems } from "../../Services/wilayas.service";
import { GlobalModule } from "../../Global/global.module";
import { DirectiveModule } from "../../shared/Directives/directive.module";
import {
  MyAccountComponent,
  OrderDetailsComponent as OrderDetailsComponentlib,
  ListCommandesComponent,
  CartComponent,
  EmptyStateComponent,
} from "admin-common";
import { AdresseComponent, SnackbarComponent } from "admin-common";

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ProfileComponent,
    AddressComponent,
    OrdersComponent,
    OrderDetailsComponent,
  ],
  imports: [
    TranslationModule,
    ListCommandesComponent,
    CommonModule,
    MyAccountComponent,
    OrderDetailsComponentlib,
    RouterModule.forChild(UserAccountRoutes),
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    GlobalModule,
    DirectiveModule,
    AdresseComponent,
    CartComponent,
    SnackbarComponent,
    EmptyStateComponent,
  ],
  exports: [],
  providers: [WilayaItems],
})
export class UserAccountModule {}
